// src/hooks/use-verify.ts

import { useEffect } from "react";
import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  useVerifyMutation,
} from "../redux/features/authApi";

import {
  setAuth,
  setLogout,
} from "../redux/slices/authApiSlice";

let initialVerificationPromise:
  Promise<unknown> | null = null;

export default function useVerify() {
  const dispatch = useDispatch();

  const { isAuthLoading } = useSelector(
    (state: any) => state.authSlice
  );

  const [verify] = useVerifyMutation();

  useEffect(() => {
    if (!isAuthLoading) {
      return;
    }

    let cancelled = false;

    const checkAuthentication = async () => {
      try {
        /*
         * React Strict Mode may run this effect twice.
         * Both executions share the same request.
         */
        if (!initialVerificationPromise) {
          initialVerificationPromise = verify()
            .unwrap()
            .finally(() => {
              initialVerificationPromise = null;
            });
        }

        await initialVerificationPromise;

        if (!cancelled) {
          dispatch(setAuth());
        }
      } catch (error) {
        console.error(
          "Initial session verification failed:",
          error
        );

        if (!cancelled) {
          dispatch(setLogout());
        }
      }
    };

    void checkAuthentication();

    return () => {
      cancelled = true;
    };
  }, [
    dispatch,
    isAuthLoading,
    verify,
  ]);
}